export default __webpack_public_path__ + "static/media/Avatar3.27be1d0b.svg";